"use strict";

//fomat
String.prototype.format = function (O) {
    var s = this.replace(/\@\{(\w+)\}/g, function (t, _o) {
        return O[_o];
    });
    return s;
};

//时间 格式化
function timeStamp2String(time, type) {
    var datetime = new Date();
    datetime.setTime(time);
    var year = datetime.getFullYear();
    var month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
    var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
    var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
    var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
    var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
    if (time) {
        if (!type) {
            return year + "-" + month + "-" + date;
        }

        if (type == '1') {
            return year + "-" + month + "-" + date + ' ' + hour + ':' + minute + ':' + second;
        }
    }
}

/**
 * 获取url中的参数
 */
function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return decodeURIComponent(r[2]);return null; //返回参数值
}

function updateCartCount(count) {
    $("#cartBadge").html(count);
}

//工具函数：显示加载状态
function showLoading($element) {}
/**
   if ($element) {
       $element.addClass('loading');
   } else {
       $('.cart-list-container').addClass('loading');
   } 
   **/


// 工具函数：隐藏加载状态
function hideLoading($element) {
    if ($element) {
        $element.removeClass('loading');
    } else {
        $('.cart-list-container').removeClass('loading');
    }
}

/**
 * 封装 AJAX 请求函数，提供统一的请求处理、防重复提交、登录过期处理等功能
 * 
 * @param {Object} options - 请求配置参数对象
 * @param {string} options.url - 请求的URL地址（必填）
 * @param {string} [options.type='GET'] - HTTP请求方法：GET、POST、PUT、DELETE等
 * @param {Object|string} [options.data] - 发送到服务器的数据
 * @param {boolean} [options.async=true] - 是否异步请求
 * @param {string} [options.dataType] - 预期服务器返回的数据类型（json、xml、text等）
 * @param {string} [options.elementId] - 需要防止重复提交的DOM元素ID
 * @param {Function} options.success - 请求成功时的回调函数（必填）
 * @param {Function} [options.customErrorHandle] - 自定义错误处理函数
 * @param {Function} [options.elseCallback] - 默认错误处理回调函数
 * @param {Function} [options.loginCallback] - 自定义登录过期处理回调函数
 * 
 * @description
 * 此函数基于 jQuery.ajax 封装，提供以下增强功能：
 * 1. 自动防重复提交机制（通过添加/移除 CSS 类控制）
 * 2. 缓存控制（URL自动添加时间戳）
 * 3. 统一的响应处理流程
 * 4. 登录过期自动跳转（默认跳转到 /logout）
 * 5. 自定义错误处理支持
 * 
 * @example
 * // 基本使用示例
 * dc_ajax({
 *     url: '/api/getData',
 *     type: 'GET',
 *     success: function(ret) {
 *         console.log('请求成功:', ret);
 *     }
 * });
 * 
 * @example
 * // 防重复提交示例
 * dc_ajax({
 *     url: '/api/submit',
 *     type: 'POST',
 *     data: { name: '张三' },
 *     elementId: 'submitBtn',
 *     success: function(ret) {
 *         alert('提交成功!');
 *     }
 * });
 * 
 * @throws {Error} 当请求失败时会在控制台输出错误信息，但不会抛出异常
 * 
 * @note 注意事项：
 * 1. 依赖 jQuery 库
 * 2. 需要在CSS中定义 .ajax-disabled-class 样式
 * 3. 服务器响应需包含 success 字段：
 *    - '1': 成功
 *    - '000023': 登录过期
 *    - 其他: 业务错误
 */
var dc_ajax = function dc_ajax(options) {
    var ajaxDisableClassName = "ajax-disabled-class";

    $.ajax({
        url: options.url + '?time=' + Math.random(),
        type: options.type,
        data: options.data,
        async: options.async || true,
        dataType: options.dataType,
        beforeSend: function beforeSend() {
            if (options.elementId) {
                // 禁用按钮防止重复提交
                if ($("#" + options.elementId).hasClass(ajaxDisableClassName)) {
                    return false;
                }

                $("#" + options.elementId).addClass(ajaxDisableClassName);
            }
        },
        success: function success(ret) {
            if (ret.success == '1') {
                options.success(ret);
            } else if (ret.success == '000023') {
                var loginCallback = function loginCallback() {
                    var href = '/logout';
                    window.location.href = href;
                };
            } else {
                if (options.customErrorHandle) {
                    options.customErrorHandle(ret);
                } else {}
            }
        },
        complete: function complete() {
            if (options.elementId) {
                $("#" + options.elementId).removeClass(ajaxDisableClassName);
            }
        },
        error: function error(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
            console.log(jqXHR.readyState);
            console.log(jqXHR.status);
        }
    });
};

//加载分页页码
var loadPage = function loadPage(totalPages, isFirst, isLast, paginationId, currentPage) {

    var pageItemTemplate = ['<a href="javascript:void(0)" class="page-btn @{active}" data-dt-idx="@{idx}" tabindex="0">@{idx}</a>'].join('');
    var pageList = [];

    if (totalPages > 1) {
        var prevBtnTemplate = ['<a href="javascript:void(0)" class="page-btn previous @{disabledClass}" data-dt-idx="0" tabindex="0">&lt;</a>'].join('');

        pageList.push(prevBtnTemplate.format({
            disabledClass: isFirst ? 'disabled' : ''
        }));

        var startPageIdx = 1;
        var endPageIdx = 1;
        if (totalPages > 7) {
            if (currentPage > 4) {
                if (totalPages - currentPage < 4) {
                    startPageIdx = totalPages - 6;
                    endPageIdx = totalPages;
                } else {
                    startPageIdx = currentPage - 3;
                    endPageIdx = currentPage + 3;
                }
            } else {
                startPageIdx = 1;
                endPageIdx = 7;
            }
        } else {
            startPageIdx = 1;
            endPageIdx = totalPages;
        }

        for (var i = startPageIdx; i <= endPageIdx; i++) {
            pageList.push(pageItemTemplate.format({
                idx: i,
                active: i == currentPage ? 'active' : ''
            }));
        }

        var nextBtnTemplate = ['<a href="javascript:void(0)" class="page-btn next @{disabledClass}" data-dt-idx="11" tabindex="0">&gt;</a>'].join('');

        pageList.push(nextBtnTemplate.format({
            disabledClass: isLast ? 'disabled' : ''
        }));

        $("#" + paginationId).html('').append(pageList.join(''));
    } else {
        $("#" + paginationId).html('').append(pageList.join(''));
    }
};

//返回缩略图
function getThumbnailURLByWidthAndHeight(naturalImgURL, width, height) {
    var url = "";
    if (!naturalImgURL) {
        return naturalImgURL;
    }

    var res = naturalImgURL.split(".");

    for (var i = 0; res && i < res.length; i++) {
        url += res[i];
        if (i == res.length - 2) {
            url += "_";
            url += width;
            url += "x";
            url += height;
        }

        if (i != res.length - 1) {
            url += ".";
        }
    }
    return url;
}
//查询搜索框 要求input框，自动生成其他附加元素
function addToSearchBox(inputElement) {
    var parentHtml = '<div class="yzm-search"></div>';
    var brotherHtml = '<div id="yzm-search" class="yzm-search_btn">搜索</div>';
    var picHtml = '<img src="/static/images/common/search-icon.png"/>';
    inputElement.wrap(parentHtml);
    inputElement.before(picHtml);
    inputElement.after(brotherHtml);
}

//弹框 （警告框，确认框，自定义框）
/**
 * 使用示例：
 * 
 * 1. 警告框：
 *    dcAlert({
 *        content: '操作成功！',
 *        okCallback: function() {
 *            console.log('用户点击了确认');
 *        }
 *    });
 * 
 * 2. 确认框：
 *    dcConfirm({
 *        content: '确定要删除吗？',
 *        okCallback: function() {
 *            console.log('用户确认删除');
 *        },
 *        cancelCallback: function() {
 *            console.log('用户取消删除');
 *        }
 *    });
 * 
 * 3. 自定义框：
 *    dcCustom({
 *        content: '<div>这是自定义内容</div>',
 *        customClass: 'custom-dialog'
 *    });
 */

var dcPopupHtml = ['<div class="dc-alert-mask">', '	<div class="dc-alert @{customClass} ">', '			<div class="dc-alert-close @{btClosenClass}">', '				<a class="dc-close" href="javascript:void(0);"></a>', '			</div>', '		<div class="dc-alert-title">', '			<div class="dc-alert-title-text">', '				<span class="title-c">@{mainTitle}</span>', '				<span class="title-e">@{subtitle}</span>', '			</div>', '		</div>', '		<div class="dc-alert-content @{customContentClass}">', '<div class="dc-alert-msg">@{content}</div>', '<div class="dc-alert-btn">', '				<input class="btn btn-cancel @{customCancelClass}" type="button" name="" value="@{btnCancelName}"></input>', '				<input class="btn btn-confirm @{customConfirmClass}" type="button" name="" value="@{btnConfirmName}"></input>', '			</div>', '		</div>', '	</div>', '</div>'].join('');

/**
 * 警告框
 * 只有一个按钮（确认按钮），用于提示用户信息
 * @param {Object} options - 配置选项
 * @param {string} [options.customClass=''] - 弹框自定义CSS类
 * @param {string} [options.btClosenClass=''] - 关闭按钮自定义CSS类
 * @param {string} [options.mainTitle='提示'] - 主标题（中文）
 * @param {string} [options.subtitle='Tips'] - 副标题（英文）
 * @param {string} [options.customContentClass=''] - 内容区域自定义CSS类
 * @param {string} options.content - 弹框显示信息（必填）
 * @param {string} [options.customCancelClass=''] - 取消按钮自定义CSS类（不显示）
 * @param {string} [options.btnCancelName=''] - 取消按钮名称（不显示）
 * @param {string} [options.customConfirmClass=''] - 确认按钮自定义CSS类
 * @param {string} [options.btnConfirmName='确认'] - 确认按钮名称
 * @param {Function} [options.okCallback] - 确认按钮回调函数
 */
function dcAlert(options) {
    // 设置默认值
    var config = $.extend({
        mainTitle: '提示',
        subtitle: '',
        btnConfirmName: '确认',
        btnCancelName: '', // 警告框不显示取消按钮
        customCancelClass: 'hide' // 隐藏取消按钮
    }, options);
    var html = dcPopupHtml.format(config);

    openDcPopup(html, options.okCallback);
}

/**
 * 确认框
 * 有两个按钮（确认和取消），用于需要用户确认的操作
 * @param {Object} options - 配置选项
 * @param {string} [options.customClass=''] - 弹框自定义CSS类
 * @param {string} [options.btClosenClass=''] - 关闭按钮自定义CSS类
 * @param {string} [options.mainTitle='确认'] - 主标题（中文）
 * @param {string} [options.subtitle='Confirm'] - 副标题（英文）
 * @param {string} [options.customContentClass=''] - 内容区域自定义CSS类
 * @param {string} options.content - 弹框显示信息（必填）
 * @param {string} [options.customCancelClass=''] - 取消按钮自定义CSS类
 * @param {string} [options.btnCancelName='取消'] - 取消按钮名称
 * @param {string} [options.customConfirmClass=''] - 确认按钮自定义CSS类
 * @param {string} [options.btnConfirmName='确认'] - 确认按钮名称
 * @param {Function} [options.okCallback] - 确认按钮回调函数
 * @param {Function} [options.cancelCallback] - 取消按钮回调函数
 */
function dcConfirm(options) {
    // 设置默认值
    var config = $.extend({
        mainTitle: '提示',
        subtitle: '',
        btnCancelName: '取消',
        btnConfirmName: '确认'
    }, options);

    var html = dcPopupHtml.format(config);
    // 如果传入了回调函数，使用回调方式
    if (config.okCallback || config.cancelCallback) {
        openDcPopup(html, config.okCallback, config.cancelCallback);
        return; // 返回 undefined
    }

    // 否则返回Promise
    return new Promise(function (resolve) {
        openDcPopup(html, function () {
            resolve(true);
        }, function () {
            resolve(false);
        });
    });
}

/**
 * 自定义框
 * 没有按钮，用于纯展示信息
 * @param {Object} options - 配置选项
 * @param {string} [options.customClass=''] - 弹框自定义CSS类
 * @param {string} [options.btClosenClass='hidden'] - 关闭按钮自定义CSS类（默认隐藏）
 * @param {string} [options.mainTitle='信息'] - 主标题（中文）
 * @param {string} [options.subtitle='Information'] - 副标题（英文）
 * @param {string} [options.customContentClass=''] - 内容区域自定义CSS类
 * @param {string} options.content - 弹框显示信息（必填）
 * @param {string} [options.customCancelClass='hidden'] - 取消按钮自定义CSS类（隐藏）
 * @param {string} [options.btnCancelName=''] - 取消按钮名称（不显示）
 * @param {string} [options.customConfirmClass='hidden'] - 确认按钮自定义CSS类（隐藏）
 * @param {string} [options.btnConfirmName=''] - 确认按钮名称（不显示）
 */
function dcCustom(options) {
    // 设置默认值
    var config = $.extend({
        mainTitle: '信息',
        subtitle: '',
        btClosenClass: 'hide', // 隐藏关闭按钮
        btnCancelName: '', // 不显示取消按钮
        btnConfirmName: '', // 不显示确认按钮
        customCancelClass: 'hide', // 隐藏取消按钮
        customConfirmClass: 'hide' // 隐藏确认按钮
    }, options);

    var html = dcPopupHtml.format(config);
    openDcPopup(html, options.okCallback, options.cancelCallback);
}

//打开弹框
function openDcPopup(html, okCallback, cancelCallback) {
    // 1. 先关闭可能已存在的弹框
    dcClose();

    // 2. 添加弹框HTML
    $("body").append(html).addClass("body_overall");

    // 3. 使用事件命名空间，便于管理
    var namespace = '.dcPopupEvents';

    // 4. 绑定取消按钮事件
    $("body").off('click' + namespace, '.dc-alert-btn .btn-cancel').on('click' + namespace, '.dc-alert-btn .btn-cancel', function () {
        if (typeof cancelCallback === 'function') {
            cancelCallback();
        }
        dcClose();
    });

    // 5. 绑定确认按钮事件
    $("body").off('click' + namespace, '.dc-alert-btn .btn-confirm').on('click' + namespace, '.dc-alert-btn .btn-confirm', function () {
        if (typeof okCallback === 'function') {
            okCallback();
        }
        dcClose();
    });

    // 6. 绑定关闭按钮事件
    $("body").off('click' + namespace, '.dc-close').on('click' + namespace, '.dc-close', function () {
        dcClose();
    });

    // 7. ESC键关闭弹框
    $(document).off('keyup' + namespace).on('keyup' + namespace, function (e) {
        if (e.key === 'Escape') {
            dcClose();
        }
    });
}

//关闭弹窗
function dcClose() {
    // 移除弹框相关元素
    $('.dc-popup, .dc-alert, .dc-modal').remove(); // 根据实际弹框类名调整

    $(".dc-alert-mask").remove();
    $("body").removeClass("body_overall");

    // 移除事件绑定
    $(document).off('.dcPopupEvents');
    $("body").off('.dcPopupEvents');
}

//工具函数：显示成功消息
function showSuccess(message) {
    dcAlert({
        mainTitle: '成功信息',
        content: message
    });
}

function showTips(message, autoCloseTime) {
    dcAlert({
        mainTitle: '成功信息',
        content: message
    });

    // 设置定时器自动关闭
    if (autoCloseTime > 0) {
        setTimeout(function () {
            dcClose();
        }, autoCloseTime);
    }
}

function showSuccess(message, okCallback) {
    dcAlert({
        mainTitle: '成功信息',
        content: message,
        okCallback: okCallback
    });
}

// 工具函数：显示错误消息
function showError(message) {
    dcAlert({
        mainTitle: '错误信息',
        content: message
    });
}

// 工具函数：显示警告消息
function showWarning(message) {
    dcAlert({
        mainTitle: '提示信息',
        content: message
    });
}

// 工具函数：格式化数字（千分位）
function formatNumber(num) {
    if (!num && num !== 0) return '0';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function loadHospitalPoint(callback) {
    dc_ajax({
        type: "post",
        url: "/security/points",
        dataType: 'json',
        elementId: '',
        error: function error(request) {
            console.log(request);
            //me.resetload();
        },
        success: function success(ret) {
            if (callback) {
                callback(ret);
            }
        }
    });
}

function getUserInfo(callback) {
    dc_ajax({
        type: "post",
        url: "/security/userinfo",
        dataType: 'json',
        elementId: '',
        error: function error(request) {
            console.log(request);
            //me.resetload();
        },
        success: function success(ret) {
            if (callback) {
                callback(ret);
            }
        }
    });
}